// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3zTG0","label":"Section_label__BWegm","contentWrap":"Section_contentWrap__3qWfA","footer":"Section_footer__15W-5","footerInner":"Section_footerInner__1StIl"};